// Completeness of an email's sections: an image cell needs a link and alt text.
// Shared by the editor (per-section status) and the email page (the Sections tab count).

export type SectionIssues = { links: number; alts: number; count: number }

type CellLike = { link?: string | null; alt?: string | null }
type SectionLike = { type?: string; cells?: CellLike[] | null }

export function sectionIssues(section: SectionLike): SectionIssues {
  if (section.type !== 'image') return { links: 0, alts: 0, count: 0 }
  const cells = section.cells || []
  const links = cells.filter((c) => !c.link?.trim()).length
  const alts = cells.filter((c) => !c.alt?.trim()).length
  return { links, alts, count: links + alts }
}

export function totalSectionIssues(sections: SectionLike[]): SectionIssues {
  return sections.reduce<SectionIssues>(
    (sum, section) => {
      const i = sectionIssues(section)
      return { links: sum.links + i.links, alts: sum.alts + i.alts, count: sum.count + i.count }
    },
    { links: 0, alts: 0, count: 0 },
  )
}

export function issueText(issues: SectionIssues): string {
  const parts: string[] = []
  if (issues.links) parts.push(`${issues.links} ${issues.links === 1 ? 'link' : 'links'}`)
  if (issues.alts) parts.push(`${issues.alts} alt ${issues.alts === 1 ? 'text' : 'texts'}`)
  return parts.length ? `${parts.join(' and ')} missing` : ''
}
